import { Typography } from '@/src/shared/components/Typography';
import styles from './FromRoomvuToVusocial.module.scss';
import Video from './Video';
import { Section } from '@/src/containers/Landings/Section';

export const FromRoomvuToVusocial = () => {
  return (
    <Section className={styles.container}>
      <div className={styles.details}>
        <Typography tag="h5" variant="heading" size="h5">
          From Roomvu to VuSocial
        </Typography>
        <Typography variant="text" size="xl" fontWeight="regular">
          {`We've evolved from Roomvu, a trusted video-marketing pioneer for
          realtors, to VuSocial, specializing in AI-generated content that's
          personalized, branded, and built specifically for insurance agents and
          financial advisors.`}
        </Typography>
        <Typography variant="text" size="xl" fontWeight="regular">
          Now powered by the same proven technology, VuSocial makes it{' '}
          <strong>effortless to produce high-quality, local videos</strong> that
          build trust and spark engagement in your industry.
        </Typography>
      </div>
      <div className={styles.videoWrapper}>
        <Video />
      </div>
    </Section>
  );
};
